declare var $: any;

export class HelpBoxComponent {
    static init() {
        $('[data-toggle="popover"]').unbind("click");
        $('[data-toggle="popover"]').popover({
            html: true,
            trigger: "manual"
        }).click(function() {
            $(this).popover("toggle");
            $(".help-box-close").remove();
            $(".popover-title").append(
                $("<button />")
                    .attr("type", "button")
                    .addClass("btn btn--none help-box-close")
                    .append($("<span />")
                        .addClass("spinner spinner--black glyphicon glyphicon-remove")));
            $(".help-box-close").click(function() {
                $(this).parents(".popover").popover("hide");
            });
        });
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/components/helpBoxComponent.ts